import type React from "react";

import type { MessageCommentReactionDto, MessageReactionDto } from "@/api/types";
import { UserAvatarLink } from "@/components/UserAvatar/UserAvatar";
import { UserFullNameLink } from "@/components/UserFullNameLink/UserFullNameLink";
import { Inline } from "@/design-system/Inline";
import { getReactionImage, getReactionLabel } from "@/helpers/reactions";
import { useTranslation } from "@/translations";

interface ReactionListItemProps {
  reaction: MessageReactionDto | MessageCommentReactionDto;
}

export function ReactionListItem({ reaction }: ReactionListItemProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <li>
      <Inline gap="lg" align="center">
        <figure className="relative">
          <UserAvatarLink user={reaction.author} />
          <span className="absolute right-0 bottom-0 translate-x-1/2 rounded-full border border-border-default bg-background-default">
            <img
              className="h-icon-inline"
              src={getReactionImage(reaction.reactionType)}
              alt={getReactionLabel(reaction.reactionType, t)}
            />
          </span>
        </figure>
        <UserFullNameLink user={reaction.author} />
      </Inline>
    </li>
  );
}
